import React from "react";
import { useNavigate } from "react-router-dom";
import { Leaf, Award, Truck, MapPin } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";
import { useSeo } from "@/lib/seo";

export default function About() {
  useSeo({
    title: "About | Metros Fried Chicken Takeaway in Epsom",
    description: "Metros is a local fried chicken takeaway in Epsom, Surrey — fresh chicken, burgers, wings and sides made to order for collection and delivery.",
    keywords: "about Metros, fried chicken Epsom, takeaway Epsom Surrey, food delivery Epsom, Metros fried chicken",
    path: "/about",
    image: "https://mymetros.co.uk/logo.png",
  });
  const { settings } = useSettings();
  const s = settings || {};
  const navigate = useNavigate();
  const Icons = [Leaf, Award, Truck, MapPin];
  return (
    <div>
      <div className="bg-metros-black text-white grain px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-3xl mx-auto">
          <p className="text-metros-red font-bold text-xs uppercase tracking-widest mb-2">About METROS</p>
          <h1 className="font-heading font-extrabold text-4xl md:text-6xl tracking-tight leading-[0.95]">Good food. Made for you.</h1>
          <p className="text-gray-300 mt-4 text-lg">{s.about}</p>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-4 md:px-6 py-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {(s.why_choose || []).map((w, i) => {
          const Ic = Icons[i % 4];
          return (
            <div key={i} className="bg-white border border-gray-100 rounded-2xl p-6 shadow-sm">
              <div className="bg-metros-red/10 text-metros-red rounded-xl p-3 w-fit mb-3"><Ic size={22} /></div>
              <h3 className="font-heading font-bold text-lg">{w.title}</h3>
              <p className="text-sm text-muted-foreground mt-1">{w.desc}</p>
            </div>
          );
        })}
      </div>
      <div className="max-w-5xl mx-auto px-4 md:px-6 pb-12">
        <div className="rounded-3xl bg-metros-red text-white p-10 text-center">
          <h2 className="font-heading font-extrabold text-3xl">Ready to order?</h2>
          <button onClick={() => navigate("/menu")} className="mt-4 bg-white text-metros-red rounded-full px-8 py-3.5 font-bold">View Menu</button>
        </div>
      </div>
    </div>
  );
}
